<template>
  <div class="stat-component">
    <template v-if="isAdminOrCeoRole">
      <h2 class="stat-component__title">Выгрузка для рассылки</h2>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-date-picker
            v-model="form.load_date_from"
            :picker-options="startPickerOptions"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            clear-icon="false"
            placeholder="Дата с"
            @change="form.load_date_to = ''"
          />
        </el-col>
        <el-col :span="12">
          <el-date-picker
            v-model="form.load_date_to"
            :picker-options="finishPickerOptions"
            :disabled="!form.load_date_from"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            clear-icon="false"
            placeholder="Дата по"
          />
        </el-col>
      </el-row>
      <el-button
        type="primary"
        round
        :disabled="isDisabled"
        :loading="isLoading"
        class="stat-component__button"
        @click.prevent="downloadReport"
      >
        Скачать
      </el-button>
    </template>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getDateOfCertainFormat, unixFromString } from '@/helpers/date'

const MILLISECOND_IN_DAY = 1000 * 60 * 60 * 24
const Documents = RepositoryFactory.get('doc')

export default {
  name: 'StatisticsByBids',
  data() {
    return {
      form: {
        load_date_from: '',
        load_date_to: '',
      },
      isLoading: false,
      startPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: time =>
          unixFromString(time) < unixFromString() - MILLISECOND_IN_DAY,
      },
      finishPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: time =>
          unixFromString(time) < unixFromString(this.form.load_date_from),
      },
    }
  },
  computed: {
    isDisabled() {
      return !this.form.load_date_from || !this.form.load_date_to
    },
  },
  methods: {
    async downloadReport() {
      this.isLoading = true
      try {
        let res = await Documents.getStatisticsForBids(this.form)

        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(new Blob([res?.data]))

        let title = `Погрузки ${getDateOfCertainFormat(
          this.form.load_date_from,
          'DD.MM.YYYY',
        )} - ${getDateOfCertainFormat(
          this.form.load_date_to,
          'DD.MM.YYYY',
        )}.rtf`

        link.setAttribute('download', title)
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        this.errHandler(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.stat-component
  height: 132px
  margin-top: 8px
  margin-left: 20px
  padding: 5px 15px
  background: #fff
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1)
  border-radius: 4px
  text-align: center
  &__title
    margin-bottom: 10px
  &__button
    margin-top: 10px
</style>
